import $ from 'jquery';
import BaseView from '../core/baseView';
import { reload } from '../validation/validation-controller';
import { register } from '../core/bootstrapper';
import * as lightbox from '../../home24/helpers/lightbox';

const RedirectedTrafficView = BaseView.extend({
  initialize: function(options) {
    this.className = options.className;
    this.showLightbox();
  },

  showLightbox: function() {
    lightbox
      .setConfig({
        $dialog: this.$el,
        className: this.className
      })
      .open();

    reload();
  }
});

/*
 register bootstrap function
 */
register(null, function() {
  var el = $('.redirected-traffic');

  if (el.length) {
    new RedirectedTrafficView({
      el,
      className: 'redirected-traffic'
    });
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/redirectedTrafficView.js
 **/